import React from "react";
import AButton from "./AButton";

let tm = {};

export default function OrderReturn(props) {
    let { model, loadOrderData, upField, invoiceStatuses } = props;

    let add = (order_item_id, cnt) => {
        $.post(
            "/order-api/order-return-change?order_id=" + model.id,
            { order_item_id, cnt },
            (response) => {
                if (response.success) {
                    loadOrderData();
                } else {
                    window.toastr.error(response.error);
                }
            }
        );
    };

    let updateOrderReturnField = (order_return_id, field, value) => {
        clearTimeout(tm[order_return_id]);

        tm[order_return_id] = setTimeout(() => {
            $.get(
                "/order-api/update-order-return-field",
                {
                    order_id: model.id,
                    order_return_id,
                    field,
                    value,
                },
                (response) => {
                    window.toastr.success(JSON.stringify(response));
                    setTimeout(() => {
                        loadOrderData();
                    }, 500);
                }
            );
        }, 1000);
    };

    return (
        <div>
            <h2>Возврат</h2>
            <table className="table table-striped table-condensed table-bordered">
                <thead>
                    <tr>
                        <th>name</th>
                        <th>cnt</th>
                        <th>reason</th>
                    </tr>
                </thead>
                <tbody>
                    {model.orderItems.map((item) => {
                        let returnItem = model.orderReturnItems.find(
                            (a) => a.order_item_id === item.id
                        );

                        return (
                            <tr key={item.id}>
                                <td>
                                    #{item.name} {item.size}
                                </td>
                                <td>
                                    <AButton onClick={() => add(item.id, -1)}>
                                        <i className="glyphicon-minus" />
                                    </AButton>
                                    <AButton>
                                        {returnItem ? returnItem.cnt : 0}
                                    </AButton>
                                    <AButton onClick={() => add(item.id, 1)}>
                                        <i className="glyphicon-plus" />
                                    </AButton>
                                </td>
                                <td>
                                    {returnItem ? (
                                        <input
                                            defaultValue={
                                                returnItem.description
                                            }
                                            onChange={(event) =>
                                                updateOrderReturnField(
                                                    returnItem.id,
                                                    "description",
                                                    event.target.value
                                                )
                                            }
                                        />
                                    ) : null}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
